import {useState, useEffect} from "react"
import {Document, Page, pdfjs} from "react-pdf"
import {useSelector} from "react-redux"

import "./pdf_file_view.scss"
import Pagination from 'components/Common/Pagination'

const AnalysisIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 22V5M9 16l7 7l7-7M9 27h14"
    />
  </svg>
)

function PDFFileView({section}) {
  const [numPages, setNumPages] = useState()

  function onDocumentLoadSuccess(e) {
    setNumPages(e._pdfInfo?.numPages)
  }

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`
  }, [])

  if (!section.image) {
    return null
  }

  return (
    <RenderPDFViewer
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      numPages={numPages}
    />
  );
}

function RenderPDFViewer({onDocumentLoadSuccess, numPages}) {
  const [pageNumber, setPageNumber] = useState(1)
  const customPageData = useSelector(
    ({customPage}) => customPage?.customPageData
  )
  const pdfUrls = (customPageData?.custom_page_section_arr ?? [])
    ?.filter(i => i.image)
    ?.map(i => ({title: i.title, url: i.image}))
  const [selectedPdfUrl, setSelectedPdfUrl] = useState(
    pdfUrls?.length ? pdfUrls[0]?.url : ""
  )

  function handleThumbnailClick(page) {
    setPageNumber(page)
  }

  const pageChange = page => {
    setPageNumber(page)
  }

  return (
    <Container>
      <div className="button-container">
        <div className="store-list">
          <label for="storeSelect">Select title:</label>
          <select
            id="storeSelect"
            name="storeSelect"
            onChange={e => setSelectedPdfUrl(e.target.value)}
            value={selectedPdfUrl}
          >
            {pdfUrls.map(({title, url}) => (
              <option value={url} key={url}>
                {title}
              </option>
            ))}
          </select>
        </div>

        {numPages > 0 && (
          <Pagination
            pages={numPages}
            current={pageNumber}
            onClick={pageChange}
          />
        )}

        <button type="button" className="download-btn" onClick={() => {
          window.open(selectedPdfUrl, '_blank')
        }}>
          <AnalysisIcon /> Download PDF
        </button>
      </div>

      <div className="pdf-split-container">
        <div className="pdf-Left">
          <Document file={selectedPdfUrl}>
            <Page pageNumber={pageNumber} />
          </Document>
        </div>
        <div className="pdf-right">
          <div className="pdf-container">
            <div className="pdf-inner">
              <Document
                file={selectedPdfUrl}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <div
                    key={`page_${index + 1}`}
                    className={`thumbnail ${
                      pageNumber === index + 1 ? "active" : ""
                    }`}
                    onClick={() => handleThumbnailClick(index + 1)}
                    style={{cursor: "pointer"}}
                  >
                    <Page pageNumber={index + 1} width={150} />
                  </div>
                ))}
              </Document>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

function Container({children}) {
  return (
    <div className="pdf-viewer pdf-canvas">
      <div className="container">{children}</div>
      <style>
        {`
          .react-pdf__Page__textContent {
              display: none !important;
          }
          .react-pdf__Page__annotations{
            display: none !important;
          }
      `}
      </style>
    </div>
  )
}

export default PDFFileView
